import React, { useContext } from 'react';
import { CardValueTitle } from 'spw-programming-projects/program-summary/components/styles';
import { Box, Grid } from '@mui/material';
import {
  CardBoldSmallValue,
  CardBoldValue,
  SmallCard,
  SmallCardRow,
  SmallCardTitle,
} from 'spw-components/project-details-tabs/program-summary/esa-single-page-summary/styles';
import { NO_DATA_TO_SHOW } from 'spw-constants';
import { asUsf } from 'spw-shared/utils';
import { ProgramSummaryCardsContext } from 'spw-esa-projects/program-summary/summary-cards';
import { useSelector } from 'react-redux';
import {
  selectHeadCountRsf,
  selectHeadcountUsf,
} from 'spw-redux/modules/program-summary/esa/selectors';
import useUnitConversion from 'spw-components/unit-conversion/hooks';
import CardIcon from 'spw-esa-projects/program-summary/card-icon';
import { ProgramSummaryCardType } from 'spw-esa-projects/program-summary/icon-selector-popover';
import { useCardIcon } from 'spw-esa-projects/program-summary/cards/hooks';

export const HeadcountUSFCard = () => {
  const { getUnit, convertArea } = useUnitConversion();
  const { showRsf, selectedCardIcon, onClickCardIcon } = useContext(
    ProgramSummaryCardsContext
  );
  const headCountRsf = useSelector(selectHeadCountRsf);
  const headcountUsf = useSelector(selectHeadcountUsf);
  const cardIcon = useCardIcon(ProgramSummaryCardType.headcountUsf);

  const handleIconClick = (event: React.MouseEvent<HTMLDivElement>) => {
    onClickCardIcon(event, cardIcon);
  };

  const isIconCardSelected =
    selectedCardIcon?.cardType === ProgramSummaryCardType.headcountUsf;

  if (!cardIcon) return null;

  return (
    <>
      {showRsf ? (
        <SmallCard $tall data-cy="headcount-rsf-usf">
          <SmallCardTitle style={{ marginBottom: 24 }}>
            Headcount {getUnit('rentable-area')} + {getUnit('area')}
          </SmallCardTitle>
          <Grid container alignItems="center">
            <Grid item xs={4}>
              <CardIcon
                iconPath={`/images/space-icons/${cardIcon.iconPath}`}
                onClick={handleIconClick}
                height={38}
                isSelected={isIconCardSelected}
              />
            </Grid>
            <Grid item xs={8}>
              <Box pl={3.5}>
                <CardBoldSmallValue
                  data-testid="headcount_rsf"
                  warning={headCountRsf < headcountUsf}
                >
                  {headCountRsf
                    ? asUsf(convertArea(headCountRsf))
                    : NO_DATA_TO_SHOW}
                </CardBoldSmallValue>
                <CardValueTitle style={{ marginBottom: 16 }}>
                  {getUnit('rentable-area')} /<br />
                  Headcount
                </CardValueTitle>
                <CardBoldSmallValue data-testid="head_count_usf_card">
                  {headcountUsf
                    ? asUsf(convertArea(headcountUsf))
                    : NO_DATA_TO_SHOW}
                </CardBoldSmallValue>
                <CardValueTitle>
                  {getUnit('area')} /<br />
                  Headcount
                </CardValueTitle>
              </Box>
            </Grid>
          </Grid>
        </SmallCard>
      ) : (
        <SmallCard>
          <SmallCardTitle>Headcount {getUnit('area')}</SmallCardTitle>
          <Grid container>
            <Grid item xs={12}>
              <SmallCardRow display="flex">
                <Box mr={2}>
                  <CardIcon
                    iconPath={`/images/space-icons/${cardIcon.iconPath}`}
                    onClick={handleIconClick}
                    height={38}
                    isSelected={isIconCardSelected}
                  />
                </Box>
                <CardBoldValue data-testid="head_count_usf_card">
                  {headcountUsf
                    ? asUsf(convertArea(headcountUsf))
                    : NO_DATA_TO_SHOW}
                </CardBoldValue>
              </SmallCardRow>
              <CardValueTitle>
                {getUnit('area')} /<br />
                Headcount
              </CardValueTitle>
            </Grid>
          </Grid>
        </SmallCard>
      )}
    </>
  );
};
